//#region src/schemas/protocol/constants.ts
const MAX_PROFILE_ID_LENGTH = 64;
const MAX_VISITED_PROFILE_IDS = 256;
const MAX_PROFILE_NAME_LENGTH = 64;
const MAX_TEXT_LENGTH = 1e5;
//#endregion
export { MAX_PROFILE_ID_LENGTH, MAX_PROFILE_NAME_LENGTH, MAX_TEXT_LENGTH, MAX_VISITED_PROFILE_IDS };

//# sourceMappingURL=constants.js.map